<div class="mat-modal-dialog overspeeding-modal">
    <h2 mat-dialog-title style="display: flex; align-items: center; justify-content: center;">
        <span class="material-icons-outlined"
            style="color: #FF0000; margin-right: 10px; position: relative; top: 1px; font-size: 20px;">
            info
        </span>
        <span
            style="color: #495057; font-size: 14px; font-weight: 500; font-family: Poppins; position: relative; top: 1px;">
            Overspeeding Notification
        </span>
    </h2>
    <div class="row mat-dialog-content d-flex">
        <div class="col-sm-12 col-md-12">
            <div style="font-size: 13px; font-family: 'Poppins'; font-weight: 400;">
                <div class="row mt-2">
                    <div class="col-sm-6">
                        <span>Trip Id:</span>
                        <span style="margin-left: 5px;">{{data.tripCode}}</span>
                    </div>
                    <div class="col-sm-6">
                        <span>Driver Name:</span>
                        <span style="margin-left: 5px;">{{data.driverName}} </span>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-sm-6">
                        <span>Vehicle No:</span>
                        <span style="margin-left: 5px;">{{data.vehicleNo}}</span>
                    </div>
                    <div class="col-sm-6">
                        <span>Violation Speed:</span>
                        <span style="margin-left: 5px;">{{data.violationSpeed}}</span>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-sm-6">
                        <span>Speed Limit:</span>
                        <span style="margin-left: 5px;">{{data.speedLimit}}</span>
                    </div>
                    <div class="col-sm-6">
                        <span>Driver No:</span>
                        <span style="margin-left: 5px;">{{data.driverContact}}</span>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-sm-6">
                        <label>Remark</label>
                        <input type="text" class="form-input margin-right-8px" placeholder="Enter Remark"
                            [(ngModel)]="remark" autocomplete="off">
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-sm-12 col-md-12 d-flex" style="justify-content:end;">
                <button class="btn red-btn-solid" (click)="submit()">Submit</button>
                <button class="btn overspeeding-black-btn-solid" (click)="onClickCancel()">Cancel</button>
            </div>
        </div>
    </div>
</div>